import React, { useEffect } from "react";
import { LoginForm } from "../Components/custom/LoginForm";
import { Box } from "@chakra-ui/react";
import { getDomainConfig } from "../Utils/dynamicBranding";
import { useThemeContext } from "../Context/ThemeContext";
import { useTheme } from "next-themes";

export const Login = () => {
  const { themeConfig } = useThemeContext();
  const { resolvedTheme } = useTheme();
  const theme = themeConfig[resolvedTheme === 'dark' ? 'dark' : 'light'];

  useEffect(() => {
    const config = getDomainConfig();
    document.title = `Login - ${config.title}`;
  }, []);

  return (
    <>
      <Box
        display="flex"
        paddingTop="5rem"
        justifyContent="center"
        minHeight="100vh"
        bg={theme.bgPrimary}
        transition="all 0.3s ease"
      >
        <LoginForm />
      </Box>
    </>
  );
};